import React, { Dispatch, useCallback, useEffect, useRef, useState } from "react";
import { Handle, Position, useReactFlow } from "reactflow";
import { CloseIcon, IconDepth, IconEarthquake, IconMagnitude, SensorNodeIcon } from "../iconSet/IconSet";
import { sourceCustomStyles, targetCustomStyles } from "../workflowCanvas/CustomStyles";
import { InputGroupPropsTypes } from "../inputComp/InputGroupType";
import InputGroup from "../inputComp/InputGroup";
import { APIGetEarthquakeData, APIRequestSaveEarthquakeData, APISaveEarthquakeData } from "../popupComp/PopupService";

export type EarthquakeTypes = {
    nodeId: string;
    nodeName: string;
    minDepth: number;
    maxDepth: number;
    minMagnitude: number;
    maxMagnitude: number;
    location: string | null;
    flowId: string;
}

export type EarthquakeNodePropsType = {
    id: string;
    data: {
        label: string;
        data: EarthquakeTypes
    }
}
const EarthquakeNode: React.FC<EarthquakeNodePropsType> = ({ id, data }) => {

    const { deleteElements } = useReactFlow();
    const [isHovering, setIsHovering] = useState(false);

    const [editWindow, setEditWindow] = useState<boolean>(false)

    const depthMinRef = useRef<HTMLInputElement | null>(null)
    const depthMaxRef = useRef<HTMLInputElement | null>(null)
    const minMagnitudeRef = useRef<HTMLInputElement | null>(null)
    const maxMagnitudeRef = useRef<HTMLInputElement | null>(null)

    const [minDepth, setMinDepth] = useState<number>(0)
    const [maxDepth, setMaxDepth] = useState<number>(0)

    const [minMagnitude, setMinMagnitude] = useState<number>(0)
    const [maxMagnitude, setMaxMagnitude] = useState<number>(0)

    // const formItems: InputGroupPropsTypes[] = [
    //     {
    //         type: "number",
    //         icon: <IconDepth width="1.3rem" color="var(--color-main-white)" />,
    //         color: "var(--color-accent-bg)",
    //         placeholder: "Enter minimum Depth",
    //         label: "Minimum Depth",
    //         name: "min_depth",
    //         componentInputElement: depthMinRef,
    //         min: 0,
    //         required: true
    //     },
    //     {
    //         type: "number",
    //         icon: <IconDepth width="1.3rem" color="var(--color-main-white)" />,
    //         color: "var(--color-accent-bg)",
    //         placeholder: "Enter maximum Depth",
    //         label: "Maximum Depth",
    //         name: "max_depth",
    //         componentInputElement: depthMaxRef,
    //         min: 0,
    //         required: true
    //     },
    //     {
    //         type: "number",
    //         icon: <IconMagnitude width="1.3rem" color="var(--color-main-white)" />,
    //         color: "var(--color-accent-bg)",
    //         placeholder: "Enter Minimum Magnitude",
    //         label: "Minimum Magnitude",
    //         name: "min_magnitude",
    //         componentInputElement: minMagnitudeRef,
    //         min: 0,
    //         required: true
    //     },
    //     {
    //         type: "number",
    //         icon: <IconMagnitude width="1.3rem" color="var(--color-main-white)" />,
    //         color: "var(--color-accent-bg)",
    //         placeholder: "Enter Maximum Magnitude",
    //         label: "Maximum Magnitude",
    //         name: "max_magnitude",
    //         componentInputElement: maxMagnitudeRef,
    //         min: 0,
    //         required: true
    //     }
    // ]

    const handleMouseOver = () => {
        setIsHovering(true);
    };
    const handleMouseOut = () => {
        setIsHovering(false);
    };

    const deleteNode = useCallback(() => {
        console.log(id);
        deleteElements({ nodes: [{ id }] });
    }, [id, deleteElements]);

    // const handleClickEdit = () => {
    //     if (!depthMinRef.current || !depthMaxRef.current || !minMagnitudeRef.current || !maxMagnitudeRef.current) return

    //     depthMinRef.current.valueAsNumber = data.data.minDepth
    //     depthMaxRef.current.valueAsNumber = data.data.maxDepth
    //     minMagnitudeRef.current.valueAsNumber = data.data.minMagnitude
    //     maxMagnitudeRef.current.valueAsNumber = data.data.maxMagnitude

    //     setEditWindow(true)
    // }

    // const handleSaveAndAddClick = async () => {
        
    //     if (!depthMinRef.current || !depthMaxRef.current || !minMagnitudeRef.current || !maxMagnitudeRef.current) return

    //     const dataSet: EarthquakeTypes = {
    //         flowId: data.data.flowId,
    //         nodeId: 'node1',
    //         nodeName: 'Earthquake',
    //         minDepth: depthMinRef.current.valueAsNumber,
    //         maxDepth: depthMaxRef.current.valueAsNumber,
    //         minMagnitude: minMagnitudeRef.current.valueAsNumber,
    //         maxMagnitude: maxMagnitudeRef.current.valueAsNumber,
    //         location: null
    //     }

    //     const body: APIRequestSaveEarthquakeData = {
    //         flowId: dataSet.flowId,
    //         minDepth: dataSet.minDepth,
    //         maxDepth: dataSet.maxDepth,
    //         minMagnitude: dataSet.minMagnitude,
    //         maxMagnitude: dataSet.maxMagnitude
    //     }

    //     const response = await APISaveEarthquakeData(body)
    //     if (response)
    //     {
    //         setEditWindow(false)
    //         initialLoad()
    //         data.data.maxDepth = dataSet.maxDepth
    //         data.data.minDepth = dataSet.minDepth
    //         data.data.minMagnitude = dataSet.minMagnitude
    //         data.data.maxMagnitude = dataSet.maxMagnitude

            
    //     }
    //     else
    //     {
    //         console.log("failed")
    //     }
    // }

    const initialLoad = async () => {
    
        const response = await APIGetEarthquakeData(data.data.flowId)

        if (response && response.data)
        {
            // depthMinRef.current.valueAsNumber = response.data.minDepth
            // depthMaxRef.current.valueAsNumber = response.data.maxDepth
            // minMagnitudeRef.current.valueAsNumber = response.data.minMagnitude
            // maxMagnitudeRef.current.valueAsNumber = response.data.maxMagnitude

            setMinDepth(response.data.minDepth)
            setMaxDepth(response.data.maxDepth)
            setMinMagnitude(response.data.minMagnitude)
            setMaxMagnitude(response.data.maxMagnitude)
        }
    }

    useEffect(() => {
        initialLoad()
    }, [])

    return (
        <div className={`earthquake-node`} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
            <div className={`container`}>
                <IconEarthquake width='3rem' color="var(--color-text)"/>
                <span className={`name`}>{data.data.nodeName}</span>
                <span className={`sensor`}>Depth - ({minDepth} - {maxDepth})</span>
                <span className={`sensor`}>Magnitude - ({minMagnitude} - {maxMagnitude})</span>
                {/* {isHovering && (
                    <div className={`node-close-ico`} onClick={deleteNode} style={{ left: '4rem' }}>
                        <CloseIcon width='1rem' color="var(--color-main-red)"/>
                    </div>
                )} */}
                {/* <button onClick={(e) => handleClickEdit()} style={{ 
                    border: 'none',
                    fontSize: '0.7rem',
                    borderRadius: '0.3rem',
                    padding: '0.2rem 0.5rem',
                    marginTop: '0.5rem',
                    cursor: 'pointer'
                 }}>Edit</button> */}
                
            </div>
            <Handle id={"eq-source-right"} type="source" position={Position.Bottom} style={{...sourceCustomStyles, background: "yellow"}}/>
            {/* <Handle id={"pro-source-bottom"} type="source" position={Position.Bottom} style={{...sourceCustomStyles, background: "yellow"}}/> */}

            
                {/* <div className={`workflow-popup-wrapper-inside`} style={{ display: editWindow ? 'flex' : 'none'}}>
                    <div className={`title`}>
                        <span>Edit data</span>
                        <CloseIcon width='1.2rem' color='var(--color-main-red)' onClick={(e) => setEditWindow(false)}/>
                    </div>
                    <div className={`earthquake-data-wrapper`}>
                        <span className='name'>Earthquake details</span>
                        <div className='fields-wrapper'>
                            {formItems.map((item, index) => (
                                <InputGroup key={index} {...item} />
                            ))}
                        </div>
                        <div className='button-wrapper'>
                            <button onClick={(e) => handleSaveAndAddClick()}>Update</button>
                        </div>
                    </div>
                </div> */}
            
        </div>
    );
};

export default EarthquakeNode;
